import React from "react";
import isEmpty from "lodash/isEmpty";
import styled from "styled-components";

const Answer = styled.label`
  display: block;
  position: relative;
  padding: 0.5rem;
  padding-left: 3rem;
  background-color: #fff;
  border: 1px solid #828282;
  border-radius: 0.5rem;
  box-shadow: ${props =>
    props.checked ? "0 0 0 3px #828282" : "0 0 0 0 rgba(0, 0, 0, 0)"};
  transition: background-color 0.15s ease-out, box-shadow 0.15s ease-out;
  cursor: pointer;

  &::before {
    content: " ";
    display: block;
    position: absolute;
    top: 50%;
    left: 1rem;
    margin-top: -1rem;
    width: 2rem;
    height: 2rem;
    background-color: ${props => props.theme.palette.primary};
    border-radius: 50%;
    opacity: ${props => (props.checked ? 1 : 0.2)};
    transition: opacity 0.15s ease-out;
  }

  &:hover {
    background-color: #f1f1f1;
  }

  @media (min-width: 640px) {
    padding: 1rem;
    padding-left: 3rem;
  }
`;

const Checkbox = styled.input``;

const Row = styled.div`
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
`;

const Title = styled.div`
  flex: 0 1 auto;
  padding: 1rem;
  font-size: 2rem;
  color: #000;
`;

const Text = styled.div`
  flex: 1 1 auto;
  padding: 1rem;
  color: #555;
  font-size: 1.8rem;
`;

const MultiChoice = props => {
  const handleChange = e => {
    const { type, id } = props;
    const { checked } = e.target;

    if (checked) {
      props.dispatch({
        type: "CHANGE_ANSWER",
        answer: { type, id },
        multiChoice: props.multiChoice
      });
    } else {
      props.dispatch({ type: "REMOVE_ANSWER", id });
    }
  };

  const checked = !!props.answer.find(a => a.id === props.id);

  return (
    <React.Fragment>
      <Checkbox
        type="checkbox"
        id={`answer-${props.id}`}
        hidden
        name="answer"
        onChange={handleChange}
        checked={checked}
      />
      <Answer htmlFor={`answer-${props.id}`} checked={checked}>
        <Row>
          <Title>{props.title}</Title>
          {props.columns === 1 && !isEmpty(props.text) && (
            <Text>{props.text}</Text>
          )}
        </Row>
      </Answer>
    </React.Fragment>
  );
};

export default MultiChoice;
